import styled from 'styled-components';

export const BehavioralChartSC = styled.div``;
